// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type GetItemJsonRequest from "../contract/GetItemJsonRequest";

export default function getItemJsonRequest(data: GetItemJsonRequest): GetItemJsonRequest {
    const result: GetItemJsonRequest = {
        __type: "GetItemJsonRequest:#Exchange",
        ...data,
    };
    
    return result;
}
